// extracted by mini-css-extract-plugin
export default {"info":"info-modal_info__O8Qn4","text":"info-modal_text__4L9ZU","source":"info-modal_source__Ndr4j","button":"info-modal_button__D8jhn"};